<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@certificateDetails">Certificate Details</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <div class="cards-container">
    <mat-card class="icons-card mb-16">
      <mat-card-content class="d-flex">
        <mat-icon class="mr-10" color="accent">card_membership</mat-icon>
        <div class="w-90">
          <div class="mb-12 mat-card-content-text mat-caption" matTooltip ellipsisTooltip>{{certificate?.description}}</div>
          <div class="date-container mat-caption mb-10">
            <mat-icon class="mr-10">date_range</mat-icon>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{certificate?.expirationDate}}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-expansion-panel class="mb-16">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@products">Products</mat-panel-title>
      </mat-expansion-panel-header>
      @for (product of certificate?.products; track product; let index = $index) {
        <div class="mat-caption mb-28" matTooltip ellipsisTooltip>{{product?.name}}</div>
      }
    </mat-expansion-panel>

    <mat-card class="material-card">
      <mat-card-content class="d-flex justify-content-between align-items-center">
        <div i18n="@@supportMaterials" class="d-inline mat-card-content-text">Download material</div>
        <div class="mat-caption d-inline">
          <a data-testid="download_certificate" (click)="downloadMyFileAndLog(certificate)" href="{{certificate?.path}}" target="_blank">
            <mat-icon class="cursor" i18n-aria-label aria-label="Download">get_app</mat-icon>
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>